import { Col, Container, Row } from "reactstrap";
import MainLayout from "../../layouts/MainLayout";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../context/auth";
import './styles.css';

export default function HomePage() {
  const { t } = useTranslation();
  const { can } = useAuth();

  const modules = [
    { titleKey: 'nav.crm',        icon: require('../../assets/images/icons/crm.png'),        link: '/crm/home', permission: 'crm.home' },
    { titleKey: 'nav.sales',      icon: require('../../assets/images/icons/sales.png'),      link: '/sales/home', permission: 'sales.home' },
    { titleKey: 'nav.purchases',  icon: require('../../assets/images/icons/purchases.png'),  link: '/purchases/home', permission: 'purchases.home' },
    { titleKey: 'nav.inventory',  icon: require('../../assets/images/icons/inventory.png'),  link: '/inventory/home', permission: 'inventory.home' },
    { titleKey: 'nav.production', icon: require('../../assets/images/icons/production.png'), link: '/production/home', permission: 'production.home' },
    { titleKey: 'nav.hr',         icon: require('../../assets/images/icons/hr.png'),         link: '/hr/home', permission: 'hr.home' },
    { titleKey: 'nav.accounting', icon: require('../../assets/images/icons/accounting.png'), link: '/accounting/home', permission: 'accounting.home' },
    { titleKey: 'nav.settings',   icon: require('../../assets/images/icons/settings.png'),   link: '/settings/home' },
  ];

  return (
    <MainLayout isMain>
      <Container>
        <h1 className="mb-5 mt-3 text-center">{t('home.welcome')}</h1>

        <Row>
          {modules
            .filter((module) => !module.permission || can(module.permission))
            .map((module, index) => (
              <Col lg="2" md="3" sm="4" xs="6" className="mb-3" key={index}>
                <div className="text-center">
                  <Link to={module.link}>
                    <img
                      src={module.icon}
                      width="100px"
                      height="100px"
                      className="mb-1"
                      alt={t(module.titleKey)}
                    />
                    <h5 className="mt-2 text-dark">{t(module.titleKey)}</h5>
                  </Link>
                </div>
              </Col>
            ))}
        </Row>
      </Container>
    </MainLayout>
  );
}
